export default {
  public: {
    more: '更多'
  },
  route: {
    home: '首页',
    about: '关于我们',
    product: '产品与服务',
    news: '资讯中心',
    contact: '联系我们'
  },
  Industry: {
    name: '经营范围',
    desc: '醇类，醛类，酸类，有机胺，有机硅，助剂等领域...',
    title_1: '表面活性剂行业',
    title_2: '纺织行业',
    title_3: '塑料工业',
    title_4: '医药&农药领域',
    title_5: '电子相关行业',
  },
  homeNews: {
    CompanyNews: '公司新闻',
    PolicyInfo: '政策法规'
  },
  news: {
    title: '新闻资讯'
  },
  prod: {
    name: '产品信息',
    attr_1: '表面活性剂行业',
    attr_2: '纺织行业',
    attr_3: '塑料工业',
    attr_4: '医药&农药领域',
    attr_5: '电子相关行业',
  },
  abouts: {
    title: '关于我们',
    sub_title: '公司简介',
    content_1: '锦徽（南京）国际贸易有限公司，位于六朝古都、江苏省会——南京市，成立于2021年02月02日。公司办公住所位于地铁1号线和5号线的竹山路站附近，到达南京南高铁站、南京禄口机场交通十分便捷。',
    content_2: '公司主营化工产品的销售、进出口业务，产品应用于众多工业领域。公司管理者均具有化学相关专业、国际贸易专业教育背景，从事相关工作十年以上，具有丰富的专业素养和操作经验。',
    content_3: '公司秉承：“诚信为本、利以义取”的经营理念，布局公司发展；公司愿通过最大程度分享收益，储备人才，建立多元化发展业务模式。'
  },
  contact: {
    title: '联系我们',
    address: '江苏省南京市江宁区科建路29号有志大厦B1座',
    people: '周先生'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js